const WORDS_PER_SECOND = 3.5;

const MINIMUM_SECONDS = 1.5;

export const expectedReadingSeconds = (...texts: string[]) => {
	const words = texts.join(' ').trim().split(/\s+/).filter(Boolean).length;
	return Math.max(MINIMUM_SECONDS, Math.round((words / WORDS_PER_SECOND) * 10) / 10);
};

export const secondsSince = (at: number) => Math.round((Date.now() - at) / 100) / 10;
